/** Global mapping from blob URLs to their original filenames. */
export const blobNames = new Map<string, string>();
